import React from "react";
import Popup from "../Popup";

const FoodCard = (props) => {
  return (
    <div>
      <div className="container m-auto py-5">
        <h3>Best Food in Tarn Taran</h3>
        <div className="row">
          {props.data.map((data) => {
            return (
              <div className="col-md-3 sfColMobile mt-3">
                <div class="">
                  <img
                    src={data.itemImage}
                    class="card-img-top foodImage"
                    alt="..."
                    style={{ borderRadius: "5%" }}
                  />
                  <div class="card-body mt-2">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <h6 class="card-title">{data.itemName}</h6>
                      </div>
                      <div className="col-md-6 text-end">
                        <button
                          className="btn btn-success fw-bold me-4"
                          style={{ fontSize: "12px", padding: "2px 8px" }}
                        >
                          3.9
                        </button>
                      </div>
                    </div>
                    <p
                      class="card-text text-secondary"
                      style={{ fontSize: "12px" }}
                    >
                      Price: ₹{data.itemPrice}
                    </p>
                    <Popup data={data} itemName={data.itemName} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FoodCard;
